import React, { useEffect, useState } from 'react';
import Alert from '@mui/material/Alert';
import {
  renderInputRow,
  renderSelectOption,
  transformRothChoicesBackToUIType,
  transformEmergencyFundsBackToUIType,
} from '../../helpers/BuildHelperComponentV3';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export const BuildIncomeRentalsComponent = (props) => {
  const {
    state,
    localPlanDetailsByPlanId,
    setLocalPlanDetailsByPlanId,
    setLastStepInParent,
    setValidationError,
  } = props;

  const booleanOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];

  const {
    moduleEstate: { rothChoices = {} } = {},
    moduleFamily: { infoCore = {} } = {},
  } = localPlanDetailsByPlanId;

  const [rothChoicesDetails, setRothChoicesDetails] = useState(rothChoices);
  const { moduleSettings: { emergencyFunds = {} } = {} } =
    localPlanDetailsByPlanId;
  const [emergencyFundsDetails, setEmergencyFundsDetails] =
    useState(emergencyFunds);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const getIsFieldsValidState = Object.keys(emergencyFunds).reduce(
    (acc, curr) => {
      return {
        ...acc,
        [curr]: true,
      };
    },
    {}
  );

  const [isFormFieldsValid, setIsFormFieldsValid] = useState(
    getIsFieldsValidState
  );

  useEffect(() => {
    if (emergencyFunds && Object.keys(emergencyFunds).length > 0) {
      let tempEmergencyFunds =
        transformEmergencyFundsBackToUIType(emergencyFunds);
      setEmergencyFundsDetails(tempEmergencyFunds);
    }
  }, [localPlanDetailsByPlanId, emergencyFunds]);

  const validateYoungerAgeAtDivWD = React.useCallback(() => {
    const { youngerAgeAtDivWD } = emergencyFundsDetails;
    return Number.isInteger(youngerAgeAtDivWD) && youngerAgeAtDivWD > 0;
  }, [emergencyFundsDetails]);

  useEffect(() => {
    const validationMethods = {
      validateYoungerAgeAtDivWD,
    };
    let newIsformFieldsValid = { ...isFormFieldsValid };
    const isAllFieldsValid = Object.keys(emergencyFundsDetails).map((key) => {
      const validationFunction = `validate${capitalizeFirstLetter(key)}`;
      let isValid = true;
      if (validationMethods[validationFunction]) {
        isValid = validationMethods[validationFunction](
          emergencyFundsDetails[key]
        );
        newIsformFieldsValid[key] = isValid;
      }
      return isValid;
    });
    setIsFormFieldsValid(newIsformFieldsValid);
    setValidationError(isAllFieldsValid.every(Boolean));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emergencyFundsDetails, validateYoungerAgeAtDivWD]);

  const withDrawRothFirst = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];

  useEffect(() => {
    if (rothChoices && Object.keys(rothChoices).length > 0) {
      let tempRothChoices = transformRothChoicesBackToUIType(rothChoices);
      setRothChoicesDetails(tempRothChoices);
    }
  }, [localPlanDetailsByPlanId, rothChoices]);

  useEffect(() => {
    setLastStepInParent(true);
  }, [setLastStepInParent]);

  return (
    <>
      <p>
        <strong>Family Rental Income</strong>
      </p>
      <Alert severity="info">
        Rental income will be captured in properties / rental
      </Alert>

      <div className="tab_main_nav">
        <div className="tab_left_nav">
          <button>
            <ArrowBackIcon /> Previous
          </button>
        </div>
        <div className="tab_right_nav">
          <button>
            Next <ArrowForwardIcon />
          </button>
        </div>
      </div>
    </>
  );
};

export default BuildIncomeRentalsComponent;
